import { type SuretyAccountId } from "@inrev/common";
import { DecisioningPanel } from "@portal/components/features/decisioning";

export const AdminDecisioningTool = ({ accountId }: { accountId: SuretyAccountId }) => (
	<div className="h-full">
		<DecisioningPanel accountId={accountId} />
	</div>
);
